import '../../../styles/index.css'
import './CustomButton.css';

function CustomButton({ texto, cor, icone, tipo, onClick }) {

    const corDaLetra = cor === 'white' ? '#A80A01' : 'white'
    const classe = 'botao' + tipo;

    return (

        <>
            <div>
                <button className={classe} onClick={onClick} style={{ backgroundColor: cor, border: cor === 'white' ? `2px solid ${corDaLetra}` : '', justifyContent: icone ? 'normal' : 'center' }} data-cy="custom-button-trigger">
                    {icone && <img src={icone} alt="Icone" data-cy="button-icon"/>}
                    <span className='bt2' style={{ color: corDaLetra }} data-cy="button-text">{texto}</span>
                </button>
            </div>
        </>
    );
}

export default CustomButton;
